// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-mrDenz","label":"label-hNRjlc","switchContainer":"switchContainer-IpwSc2","switch":"switch-ss0JDv"};